const translations = {
    apply: 'Apply',
    noEntry: 'No-Entry'
};

export default translations;
